export default __webpack_public_path__ + "static/media/Nukak-logo.ad7bec12.png";